import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../assets/style-helpers.scss';
import { InputWidthValues } from '../../../ui/gzInput';

export const templateWebAccessControlSchedulerForm = document.createElement('template');

templateWebAccessControlSchedulerForm.innerHTML = `
<style>${commonStyles}</style>
<style>${styles}</style>
<style>${styleHelpersStyles}</style>
<div class="wrapper">

  <div class="content">

    <gz-title id="scheduleTitle" class="pb-5" fontweight="400" fontsize="20"></gz-title>

    <gz-form-field id="inputScheduleNameFormField" required>
        <gz-input gz-form-input inputWidth=${InputWidthValues.XLARGE}></gz-input>
    </gz-form-field>

    <gz-form-field class="pt-1 hidden" id="btnToggleSwitchAllowChange" >
        <gz-toggle gz-form-input></gz-toggle>
      <gz-input-error></gz-input-error>
    </gz-form-field>

    <div class="grid">
        <gz-grid-view class="grid-view" removeFilters hideGridRefresh disableGridSettings></gz-grid-view>
    </div>

    <gz-info-box id="warningMessageSubschedules" severity="warning" class="pt-3 hidden" style="padding-left:0"></gz-info-box>

    <div class="form-section pb-3 pt-3">
        <gz-title id="subscheduleTitle" class="pb-2" fontweight="400" fontsize="16"></gz-title>

        <gz-form-field id="subscheduleNameFormField">
            <gz-input gz-form-input inputWidth=${InputWidthValues.XLARGE}></gz-input>
        </gz-form-field>

        <div class="categories-container">
          <gz-enum-filter class="pb-2" id="selectBoxCategories" labelWidth=${InputWidthValues.XLARGE}></gz-enum-filter>
          <gz-form-field class="pl-1" id="allWebsites">
            <gz-checkbox gz-form-input></gz-checkbox>
          </gz-form-field>
        </div>

        <gz-form-field id="checkboxShowAlerts" class="pb-3">
          <gz-checkbox gz-form-input errortooltiptext="" color="primary"></gz-checkbox>
          <gz-input-error></gz-input-error>
        </gz-form-field>

        <gz-form-field id="selectBoxActionFieldForm" required>
          <gz-dropdown id="selectBoxAction" gz-form-input></gz-dropdown>
        </gz-form-field>

        <gz-form-field id='multiselectStartWithFieldForm' required>
          <gz-multiselect-group gz-form-input></gz-multiselect-group>
          <gz-input-error></gz-input-error>
        </gz-form-field>

        <div class="flex-group" style="height:50px;">
          <gz-form-field id="timePickerStart" required>
            <gz-time-picker gz-form-input></gz-time-picker>
            <gz-input-error></gz-input-error>
          </gz-form-field>
          <gz-text id="andLabel" class="pl-2 pr-2 pt-1" fontweight="400" fontsize="12"></gz-text>
          <gz-form-field id="timePickerEnd" required>
            <gz-time-picker gz-form-input></gz-time-picker>
            <gz-input-error style="width:250px;"></gz-input-error>
          </gz-form-field>
        </div>

        <div class="flex-group pt-3">
          <gz-button class="pr-5" id="btnUpdateScheduler" type="outline"></gz-button>
          <gz-button type="outline" id="btnAddNewScheduler" color="secondary"><span class="icon ds-icon-add"></span><span class="button-text" id="addNewSchedulerLabel"></span></gz-button>
        </div>
    </div>

  </div>

  <div class="footer">
      <gz-button class="footer--button" id="btnSave"></gz-button>
      <gz-text id="anotherCompanyMessage" class="hidden" fontWeight="400" fontSize="14" style="line-height:32px"></gz-text>
      <gz-button class="footer--button" id="btnCancel" type="outline" color="secondary"></gz-button>
  </div>

</div>
`;
